import React, { useEffect, useState } from 'react';
import { getAvailableQuiz } from '../../api/quiz';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip} from '@mui/material';
import DoDisturbOnTwoToneIcon from '@mui/icons-material/DoDisturbOnTwoTone';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import HorizontalRuleTwoToneIcon from '@mui/icons-material/HorizontalRuleTwoTone';

type QuizType = {
  answerType: string
  disabled: boolean
  id: string
  minute: number | null
  options: string[] | { id: string, option: string }[]
  text: string
  triggerToAsk: null | string
}

const columns = [
  { id: 'text', label: 'Quiz text' },
  { id: 'timeDisplayed', label: 'When question is displayed' },
  { id: 'disabled', label: 'Status' },
  { id: 'options', label: 'Answer options' }
];

const LiveQuiz = () => {
  const [liveQuizList, setLiveQuizList] = useState<QuizType[]>([]);
  
  useEffect(() => {
    (async () => {
      setLiveQuizList(await getAvailableQuiz());
    })()
  }, []);
  
  const handleRowItem = (valueType: string, value: any, item: QuizType) => {
    switch (valueType) {
      case 'disabled': {
        return value ? <div>Disabled <DoDisturbOnTwoToneIcon color="error" /></div> :
          <div>Enabled <CheckCircleTwoToneIcon color="success" /></div>;
      }
      case 'options': {
        return <div>{
          value?.map((item: { id: string, option: string }) => (
            <p key={item.id}>{item.option}</p>
          ))
        }</div>
      }
      case 'timeDisplayed': {
        return <span>{item.minute !== null ? item.minute + ' minute' : item.triggerToAsk}</span>
      }
      default: return <span>{value || <HorizontalRuleTwoToneIcon color="disabled" />}</span>;
    }
  };
  
  const handleTooltipPreview = (valueType: string, value: any, item: any) => {
    switch (valueType) {
      case 'disabled': {
        return <span>{value ? 'Live quiz is disabled' : 'Live quiz is enabled'}</span>
      }
      case 'options': {
        return <div>{
          value?.map((item: { id: string, option: string }) => (
            <p key={item.id}>{item.option}</p>
          ))
        }</div>
      }
      case 'timeDisplayed': {
        return <span>{item.minute !== null ? item.minute + ' minute' : item.triggerToAsk}</span>
      }
      default: return <span>{value || <DoDisturbOnTwoToneIcon color="warning"/>}</span>;
    }
  };
  
  return (
    <div>
      <TableContainer sx={{ maxHeight: "70vh", width: '100%', position: 'relative', marginBottom: '20px' }}>
        <Table stickyHeader aria-labelledby="tableTitle" size={"small"}>
          <TableHead>
            <TableRow>
              {liveQuizList.length > 0 && columns.map((item: any) => (
                <TableCell
                  key={item.id}
                  align="left"
                  style={{ minWidth: 50, fontWeight: 700 }}
                >
                  {item.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {liveQuizList.map((row: any, index: number) => {
              return (
                <TableRow hover tabIndex={-1} key={index.toString()}>
                  {columns.map((column) => {
                    return (
                      <TableCell key={column.id} align="left">
                        <Tooltip title={handleTooltipPreview(column.id, row[column.id], row)} placement="top">
                          {handleRowItem(column.id, row[column.id], row)}
                        </Tooltip>
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default LiveQuiz;